import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-emp-entenda {
  padding: 40px 0;
}

#renegociacao25-emp-entenda .entenda-conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

#renegociacao25-emp-entenda .entenda-conteudo img {
  display: flex;
  width: 180px;
  height: 180px;
  justify-content: center;
  align-items: center;
}

#renegociacao25-emp-entenda .entenda-conteudo .entenda-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#renegociacao25-emp-entenda .entenda-conteudo .entenda-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px; 
}

#renegociacao25-emp-entenda .entenda-conteudo .entenda-texto {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

#renegociacao25-emp-entenda .entenda-conteudo .entenda-texto b {
  font-weight: 800;
}


@media (min-width: 992px) {
  #renegociacao25-emp-entenda {
    margin-top: 0;
    padding-bottom: 64px;
  }

  #renegociacao25-emp-entenda .entenda-conteudo {
    flex-direction: row;
    gap: 32px;
  }
  
  #renegociacao25-emp-entenda .entenda-conteudo img {
    width: 256px;
    height: 256px;
  }

  #renegociacao25-emp-entenda .entenda-conteudo .entenda-titulo {
    font-size: 56px;
    line-height: 120%; 
  }
  
  #renegociacao25-emp-entenda .entenda-conteudo .entenda-texto {
    font-size: 24px;
    line-height: 36px;
  }
}`;

export default styles;